<!--<pre style="background:#222;color:#0f0;padding:1rem;font-size:12px;white-space:pre-wrap;">-->
<!--DEBUG-->
<!--currentCheck: {{ facade.currentCheck() | json }}-->
<!--  currentUser: {{ facade.currentUser() | json }}-->
<!--  isCurrentUserInvolvedInCheck: {{ permission.isCurrentUserInvolvedInCheck() }}-->
<!--  isCurrentUserProjectManagerOrProjectDeputyManager: {{ permission.isCurrentUserProjectManagerOrProjectDeputyManager() }}-->
<!--</pre>-->

@if (facade.currentCheck()
&& permission.isCurrentUserInvolvedInCheck()
|| facade.currentCheck()
&& permission.isCurrentUserProjectManagerOrProjectDeputyManager()) {

  <app-check-header-bar />

  <div class="pending-check-container">
    <app-check-info-card />

    @if((facade.checkInfoViewModel()?.status  ?? 0) === 0
    && permission.isCurrentUserChecker11()){
      <mat-card class="card-base selfcheck">
        <mat-card-header>
          <mat-card-title> Checkliste Eigenkontrolle </mat-card-title>
        </mat-card-header>

        <mat-card-content class="card-content">
          <app-checklist-selfcheck style="padding-bottom: 2rem;"/>

          @if(!selfCheckDone()){
            <div class="warn-box">
              <mat-icon class="warn-icon">error</mat-icon>
              <span class="warn-msg">
                            <b>Sie müssen eine Eigenkontrolle durchführen.</b>
                        </span>
            </div>
          }

          @if(checkerIsCreator() && !checkerIsConsultant()){
            <div class="warn-box">
              <mat-icon class="warn-icon">error</mat-icon>
              <span class="warn-msg">
                            <b>Prüfer Kontrolle 1:<br> Der Prüfer darf nur der Ersteller der Kontrolle sein, wenn eine gutachterliche Tätigkeit vorliegt.</b>
                        </span>
            </div>
          }

          @if(checkerIsConsultant()){
            <div class="consultant-info-box">
              <mat-icon class="consultant-info-icon">gavel</mat-icon>
              <span class="consultant-info-msg">
                            <b>Gutachterliche Tätigkeit aktiv</b> – Kontrolle 1-2 wird übersprungen. Der Check geht direkt weiter zu Kontrolle 2.
                        </span>
            </div>
          }
        </mat-card-content>
      </mat-card>
    }

    <mat-card class="card-base comments">
      <mat-card-header>
        <mat-card-title class="card-title">
          Allgemeine Kommentare
        </mat-card-title>
      </mat-card-header>

      <mat-card-content class="card-content">
        @if (!permission.isReadOnly()) {
          <form (ngSubmit)="addComment(commentContent.value); commentContent.value = ''" class="new-comment-formfield">
            <mat-form-field style="flex: 1;">
              <input matInput placeholder="Kommentar eingeben" name="newComment" #commentContent>
            </mat-form-field>
            <button matButton="outlined" type="submit">Speichern</button>
          </form>
        }

        <app-comment-component
          [comments]="facade.generalComments() | sortCommentsDesc"
          [currentUser]="facade.currentUser()"
          [currentCheckStatus]="facade.checkInfoViewModel()?.status"
          [isReadOnly]="permission.isReadOnly()"
          (doneToggled)="onCommentDoneToggled($event)"
          (severityToggled)="onCommentSeverityToggled($event)"
          (commentDeleted)="onCommentDeleted($event)" />
      </mat-card-content>
    </mat-card>
  </div>

  @if (facade.documentCommentsIncomplete()) {
    <div class="warn-box">
      <mat-icon class="warn-icon">error</mat-icon>
      <span class="warn-msg">
              <b>Dokumentenbezogene Kommentare konnten nicht vollständig geladen werden.</b>
              Die Zuordnung der Kommentare ist eventuell unvollständig – bitte Seite neu laden.
            </span>
    </div>
  }

  <app-document-comments-card />

} @else if (!facade.currentCheck()) {
  <p style="margin: 2rem; color: var(--mat-sys-on-surface-variant);">Bitte wählen Sie eine Kontrolle aus der Liste aus.</p>
} @else {
  <p style="margin: 2rem; color: var(--mat-sys-on-surface-variant);">Sie sind nicht beteiligt in der aktuellen Kontrolle.</p>
}
